import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { useAnnonces } from "../context/AnnoncesContext";

const WILAYAS = [
  { id: "Oran",        aliases: ["Oran", "oran"],                           lat: 35.6969, lng: -0.6331 },
  { id: "Mostaganem", aliases: ["Mostaganem", "mostaganem"],                lat: 35.9310, lng:  0.0892 },
  { id: "Chlef",       aliases: ["Chlef", "chlef"],                          lat: 36.1650, lng:  1.3317 },
  { id: "Tipaza",      aliases: ["Tipaza", "tipaza"],                        lat: 36.5911, lng:  2.4494 },
  { id: "Alger",       aliases: ["Alger", "alger", "Algiers"],               lat: 36.7372, lng:  3.0865 },
  { id: "Béjaïa",      aliases: ["Béjaïa", "Bejaia", "bejaia", "béjaïa"],   lat: 36.7515, lng:  5.0564 },
  { id: "Jijel",       aliases: ["Jijel", "jijel"],                          lat: 36.8200, lng:  5.7660 },
  { id: "Skikda",      aliases: ["Skikda", "skikda"],                        lat: 36.8760, lng:  6.9060 },
  { id: "Annaba",      aliases: ["Annaba", "annaba"],                        lat: 36.9000, lng:  7.7667 },
];

function findWilaya(localisation) {
  if (!localisation) return null;
  const loc = localisation.toLowerCase().trim();
  return WILAYAS.find(w => w.aliases.some(a => loc.includes(a.toLowerCase())));
}

function MapAlgerie() {
  const { annonces } = useAnnonces();
  const [activeWilaya, setActiveWilaya] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const mapRef = useRef(null);
  const mapInstanceRef = useRef(null);
  const markersRef = useRef([]);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const countByWilaya = {};
  annonces.forEach(a => {
    const w = findWilaya(a.localisation);
    if (w) countByWilaya[w.id] = (countByWilaya[w.id] || 0) + 1;
  });

  const getAnnoncesByWilaya = (wilayaId) =>
    annonces.filter(a => {
      const w = findWilaya(a.localisation);
      return w && w.id === wilayaId;
    }).slice(0, 4);

  useEffect(() => {
    if (!document.getElementById("leaflet-css")) {
      const link = document.createElement("link");
      link.id = "leaflet-css";
      link.rel = "stylesheet";
      link.href = "https://unpkg.com/leaflet@1.9.4/dist/leaflet.css";
      document.head.appendChild(link);
    }

    const loadLeaflet = () => {
      if (window.L) { initMap(window.L); return; }
      const script = document.createElement("script");
      script.src = "https://unpkg.com/leaflet@1.9.4/dist/leaflet.js";
      script.onload = () => initMap(window.L);
      document.head.appendChild(script);
    };

    const initMap = (L) => {
      if (mapInstanceRef.current) return;
      const map = L.map(mapRef.current, {
        center: [36.5, 3.5],
        zoom: 6,
        zoomControl: true,
        scrollWheelZoom: false,
      });
      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: '© <a href="https://www.openstreetmap.org/">OpenStreetMap</a>',
        maxZoom: 18,
      }).addTo(map);
      mapInstanceRef.current = map;

      WILAYAS.forEach(w => {
        const count = countByWilaya[w.id] || 0;
        const color = count === 0 ? "#94a3b8" : count <= 2 ? "#5eead4" : "#0d9488";
        const size = count > 0 ? 38 : 22;
        const icon = L.divIcon({
          className: "",
          html: `<div style="background:${color};color:white;border:3px solid white;border-radius:50%;width:${size}px;height:${size}px;display:flex;align-items:center;justify-content:center;font-size:13px;font-weight:700;box-shadow:0 2px 8px rgba(0,0,0,0.3);cursor:pointer;font-family:sans-serif;">${count > 0 ? count : "·"}</div>`,
          iconSize: [size, size],
          iconAnchor: [size / 2, size / 2],
        });
        const marker = L.marker([w.lat, w.lng], { icon })
          .addTo(map)
          .bindTooltip(`<b>${w.id}</b><br/>${count} annonce${count > 1 ? "s" : ""}`, {
            permanent: false, direction: "top", className: "marina-tooltip"
          })
          .on("click", () => setActiveWilaya(w.id));
        markersRef.current.push({ wilaya: w.id, marker });
      });
    };

    loadLeaflet();
    return () => {
      if (mapInstanceRef.current) {
        mapInstanceRef.current.remove();
        mapInstanceRef.current = null;
      }
    };
  }, []);

  const selectedAnnonces = activeWilaya ? getAnnoncesByWilaya(activeWilaya) : [];
  const selectedCount = activeWilaya ? (countByWilaya[activeWilaya] || 0) : 0;

  const Panel = () => (
    <div style={{ padding: "16px" }}>
      {activeWilaya ? (
        <>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "12px" }}>
            <h4 style={{ fontSize: "15px", fontWeight: "700", color: "#1f2937", margin: 0 }}>📍 {activeWilaya}</h4>
            <span style={{ fontSize: "12px", color: "#0d9488", fontWeight: "600" }}>{selectedCount} annonce{selectedCount > 1 ? "s" : ""}</span>
          </div>
          {selectedAnnonces.length > 0 ? (
            <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
              {selectedAnnonces.map(a => (
                <Link key={a.id} to={`/annonce/${a.id}`}
                  style={{ display: "flex", gap: "10px", alignItems: "center", padding: "8px", backgroundColor: "#f8fafc", borderRadius: "8px", textDecoration: "none", border: "1px solid #e5e7eb" }}>
                  <img src={a.image} alt={a.nom}
                    style={{ width: "48px", height: "40px", objectFit: "cover", borderRadius: "6px", flexShrink: 0 }}
                    onError={e => { e.target.src = "https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=100"; }} />
                  <div style={{ overflow: "hidden" }}>
                    <div style={{ fontSize: "13px", fontWeight: "600", color: "#1f2937", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{a.nom}</div>
                    <div style={{ fontSize: "12px", color: "#0d9488", fontWeight: "600" }}>{a.prix ? `${Number(a.prix).toLocaleString()} DA` : "Sur demande"}</div>
                  </div>
                </Link>
              ))}
              {selectedCount > 4 && (
                <Link to={`/catalogue?localisation=${encodeURIComponent(activeWilaya)}`}
                  style={{ textAlign: "center", fontSize: "13px", color: "#0d9488", fontWeight: "600", padding: "8px", textDecoration: "none", display: "block" }}>
                  Voir toutes les annonces →
                </Link>
              )}
            </div>
          ) : (
            <p style={{ fontSize: "13px", color: "#9ca3af", textAlign: "center", padding: "20px 0" }}>Aucune annonce dans cette wilaya</p>
          )}
        </>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "20px", textAlign: "center" }}>
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#cbd5e1" strokeWidth="1.5" style={{ marginBottom: "12px" }}>
            <path d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
            <circle cx="12" cy="11" r="3"/>
          </svg>
          <p style={{ fontSize: "13px", color: "#9ca3af" }}>Cliquez sur une wilaya<br/>pour voir les annonces</p>
        </div>
      )}
    </div>
  );

  return (
    <div style={{ backgroundColor: "white", borderRadius: "12px", border: "1px solid #e5e7eb", overflow: "hidden", boxShadow: "0 1px 3px rgba(0,0,0,0.08)" }}>
      {/* Header */}
      <div style={{ padding: "16px 20px", borderBottom: "1px solid #e5e7eb", display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: "10px" }}>
        <div>
          <h3 style={{ fontSize: "16px", fontWeight: "700", color: "#1f2937", margin: 0 }}>📍 Carte des annonces</h3>
          <p style={{ fontSize: "13px", color: "#6b7280", margin: "2px 0 0" }}>Cliquez sur une wilaya pour voir les annonces</p>
        </div>
        <div style={{ display: "flex", gap: "12px", fontSize: "12px", color: "#6b7280", alignItems: "center" }}>
          <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <span style={{ width: "12px", height: "12px", borderRadius: "50%", backgroundColor: "#94a3b8", display: "inline-block" }}></span>0 annonce
          </span>
          <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <span style={{ width: "12px", height: "12px", borderRadius: "50%", backgroundColor: "#5eead4", display: "inline-block" }}></span>1-2
          </span>
          <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <span style={{ width: "12px", height: "12px", borderRadius: "50%", backgroundColor: "#0d9488", display: "inline-block" }}></span>3+
          </span>
        </div>
      </div>

      {/* ✅ CORRECTION : Layout responsive */}
      {isMobile ? (
        // Mobile : carte pleine largeur + panel en dessous
        <div>
          <div ref={mapRef} style={{ width: "100%", height: "300px" }} />
          <div style={{ borderTop: "1px solid #e5e7eb" }}>
            <Panel />
          </div>
        </div>
      ) : (
        // Desktop : carte + panel côte à côte
        <div style={{ display: "flex", height: "420px" }}>
          <div ref={mapRef} style={{ flex: 1, minWidth: 0 }} />
          <div style={{ width: "260px", borderLeft: "1px solid #e5e7eb", overflowY: "auto", flexShrink: 0 }}>
            <Panel />
          </div>
        </div>
      )}

      <style>{`
        .marina-tooltip { background: #1e293b !important; color: white !important; border: none !important; border-radius: 6px !important; font-size: 12px !important; padding: 4px 8px !important; }
        .marina-tooltip::before { display: none !important; }
        .leaflet-control-attribution { font-size: 10px; }
      `}</style>
    </div>
  );
}

export default MapAlgerie;